// extracted by mini-css-extract-plugin
module.exports = {"container":"Image_container__1SMWd","big_size":"Image_big_size__2nhQ1","shop_size":"Image_shop_size__152uR"};